module.exports = __webpack_public_path__ + "img/banner-4.385cda22.jpg";